import React, { useContext, useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { Row, Col, Card, Table, Modal, Button, Tab, Nav, Spinner } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'react-moment';
import { getProjectSummaryDetails } from '../../../store/actions/ProjectActions';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';
import ProgressReport from "../Components/ProgressReport";

const ViewSummary = (props) => {
    const dispatch = useDispatch();
    const { pid, rid } = useParams();

    useEffect(() => {
        if (pid && rid) {
            dispatch(globalLoadingAction(true));
            dispatch(getProjectSummaryDetails(pid, rid, props.history));
        }
    }, [pid, rid]);



    return (
        <>
            <div className="row">

                <div className="breadcrumb-container">
                    <ul>
                        <li>
                            <Link to={"#"}>Reporting</Link>
                        </li>
                        <li><i className="fa fa-angle-right"></i></li>
                        <li>
                            <Link to={"/generated-report"}>Generated Report</Link>
                        </li>
                        <li><i className="fa fa-angle-right"></i></li>
                        <li>
                            <Link to={"#"}>Project Information</Link>
                        </li>
                    </ul>
                </div>

                <div className="title-body-container">
                    <div className="title-body mb-3">
                        <h3>Project Information</h3>
                    </div>


                </div>
                <div className="account-setting-content">
                    <Col lg={12}>
                        <Card className='m-0'>
                            <Card.Body>
                                <div>
                                    {/* {props?.progressBarDetails?.legends?.length > 0 && (
                                        <ProgressReport
                                            legends={props?.progressBarDetails?.legends ?? []}
                                            step={(props?.progressBarDetails?.step ?? 0) - 2}
                                        />)} */}

                                    <div className="sammary-group-view">
                                        <div className="sammary-label-group-inline">
                                            <label className="sammary-label"><strong>Project ID</strong>:</label>
                                            <label className="sammary-label">{props.projectDetails?.project_id}</label>

                                        </div>
                                        <div className="sammary-label-group-inline">
                                            <label className="sammary-label"><strong>Project Status</strong>:</label>
                                            <label className="sammary-label">{props.projectDetails?.status == 1 ? "Active" : "Inactive"}</label>
                                        </div>
                                        {/* <div className="sammary-label-group">
                                            <label className="sammary-label"><strong>Project ID</strong>: {props.projectDetails?.project_id}</label>
                                            <label className="sammary-label"><strong>Project Status</strong>: {props.projectDetails?.status == 1 ? "Active" : "Inactive"}</label>
                                        </div> */}
                                        <div className="sammary-label-group-inline">
                                            <label className="sammary-label"><strong>Start Date</strong>:</label>
                                            <label className="sammary-label"> <Moment format="D MMM YYYY" withTitle>{props.projectDetails?.start_date}</Moment></label>
                                            <label className="sammary-label"><strong>End Date</strong>:</label>
                                            <label className="sammary-label"><Moment format="D MMM YYYY" withTitle>{props.projectDetails?.end_date}</Moment></label>
                                        </div>

                                        <div className="sammary-label-group-inline">
                                            <label className="sammary-label"><strong>Group Name</strong>:</label>
                                            <label className="sammary-label">{props.projectDetails?.group_description}</label>
                                            <label className="sammary-label"><strong>Group ID</strong>:</label>
                                            <label className="sammary-label">{props.projectDetails?.group_unique_id}</label>
                                        </div>
                                        <div className="sammary-label-group-inline">
                                            <label className="sammary-label"><strong>Project Type</strong>:</label>
                                            <label className="sammary-label">{(() => {
                                                switch (props.projectDetails?.project_type) {
                                                    case 1:
                                                        return 'Internal'
                                                    case 2:
                                                        return 'External'
                                                    default:
                                                        return null
                                                }
                                            })()}</label>



                                        </div>
                                        <div className="sammary-label-group-inline">
                                            <label className="sammary-label"><strong>Client Name</strong>:</label>
                                            <label className="sammary-label">{props.projectDetails?.client_name}</label>
                                        </div>
                                        <div className="sammary-label-group-inline">
                                            <label className="sammary-label"><strong>Rate</strong>:</label>
                                            <label className="sammary-label">{props.projectDetails?.rate ? '$' + props.projectDetails?.rate : ''}</label>
                                        </div>
                                        <div className="sammary-label-group-inline">
                                            <label className="sammary-label"><strong>Project Description</strong>:</label>
                                            <label className="sammary-label" style={{ width: 'auto' }}>{props.projectDetails?.description}</label>
                                        </div>
                                    </div>

                                    {/* <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <strong>ID</strong>
                                                </th>
                                                <th>
                                                    <strong>Description</strong>
                                                </th>
                                                <th>
                                                    <strong>Rate</strong>
                                                </th>
                                                <th>
                                                    <strong>Start Date</strong>
                                                </th>
                                                <th>
                                                    <strong>End Date</strong>
                                                </th>
                                                <th>
                                                    <strong>Status</strong>
                                                </th>
                                                <th>
                                                    <strong>Type</strong>
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{props.projectDetails?.project_id}</td>
                                                <td>{props.projectDetails?.title}</td>
                                                <td>{props.projectDetails?.rate ? props.projectDetails?.rate + '/-' : ''}</td>
                                                <td><Moment format="D MMM YYYY" withTitle>{props.projectDetails?.start_date}</Moment></td>
                                                <td><Moment format="D MMM YYYY" withTitle>{props.projectDetails?.end_date}</Moment></td>
                                                <td>
                                                    <Button
                                                        className="btn-xs"
                                                        variant={props.projectDetails?.status == 1 ? "success" : "danger"}
                                                    >
                                                        {props.projectDetails?.status == 1 ? "Active" : "Inactive"}
                                                    </Button>
                                                </td>
                                                <td>
                                                    {(() => {
                                                        switch (props.projectDetails?.project_type) {
                                                            case 1:
                                                                return <Button
                                                                    className="btn-xs"
                                                                    variant="info"
                                                                >INT</Button>
                                                            case 2:
                                                                return <Button
                                                                    className="btn-xs"
                                                                    variant="warning"
                                                                >EXT</Button>
                                                            default:
                                                                return null
                                                        }
                                                    })()}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table> */}
                                </div>

                            </Card.Body>
                        </Card>
                        <div>
                            <p><strong>Note:</strong> Use increments of 0.25 (15 minutes) when recording hours.</p>
                        </div>
                    </Col>
                </div>
            </div>

        </>
    )
}

const mapStateToProps = (state) => {
    return {
        screenVisible: state.timeCard.screenVisible,
        systemAdmin: state.auth.systemAdmin,
        showLoading: state.clients.showLoading,
        projectDetails: state.project.projectDetails,
        progressBarDetails: state.project.progressBarDetails,
    };
};
export default connect(mapStateToProps)(ViewSummary);